import { render, staticRenderFns } from "./review_drawer.vue.js?vue&type=template&id=7515dbc6!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./review_drawer.vue?vue&type=template&id=7515dbc6"
import script from "./review_drawer.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./review_drawer.vue?vue&type=script&lang=js"
export * from "./review_drawer.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./review_drawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports